import { ASSETS } from "../utils/config";

export const fileIcons = {
    doc: ASSETS.doc,
    docx: ASSETS.doc,
    pdf: ASSETS.pdf,
    xls: ASSETS.xls,
    xlsx: ASSETS.xls,
    ppt: ASSETS.ppt,
    pptx: ASSETS.ppt,
    csv: ASSETS.xls,
    "g-docs":ASSETS.GDocs,
    "g-slides":ASSETS.GSlides,
    "g-forms":ASSETS.GForms,
    "g-sheets":ASSETS.GSheets,
    "g-drive":ASSETS.GDrive,
    "onedrive":ASSETS.OneDrive
  };